import CheckIcon from '@mui/icons-material/Check';
import { List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IProductFeature } from 'services/api/entities';
import {
  ComingSoonText,
  StyledListItemIcon,
  StyledListItemText,
} from './styled';

type PropsType = {
  features: IProductFeature[];
};

const FeaturesList = ({ features }: PropsType) => {
  const { t } = useTranslation();

  return (
    <List disablePadding data-testid="upsell-features-list">
      {features.map((feature) => (
        <ListItem disablePadding key={feature.name.replace(' ', '-')}>
          <StyledListItemIcon>
            <CheckIcon fontSize="small" color="inherit" />
          </StyledListItemIcon>
          {feature.isComingSoon ? (
            <StyledListItemText
              primary={
                <>
                  {`${feature.name} `}
                  <ComingSoonText>
                    {t('distribution:infoSection:comingSoon')}
                  </ComingSoonText>
                </>
              }
            />
          ) : (
            <StyledListItemText primary={feature.name} />
          )}
        </ListItem>
      ))}
    </List>
  );
};

export default FeaturesList;
